import { type UseQueryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type { TeamsResponse } from '@/common/api/types/teams';
import { associateById } from '@/common/utils/associateById';
import { TeamsApi } from '@/features/teams/api/team';
import { teamsQueryKeys } from '@/features/teams/queryKeys';

export const getTeamsQueryOptions = () => {
  return {
    queryKey: teamsQueryKeys.all(),
    queryFn: () => TeamsApi.getTeams(),
  };
};

export const useSuspenseGetTeamsQuery = (
  options: Partial<Omit<UseQueryOptions<TeamsResponse>, 'queryKey' | 'queryFn'>> = {},
) => {
  return useSuspenseQuery({ ...getTeamsQueryOptions(), ...options });
};

export const useGetTeamsQuery = (options: Partial<UseQueryOptions<TeamsResponse>> = {}) => {
  return useQuery({ ...getTeamsQueryOptions(), ...options });
};

export const useGetTeamsByIdQuery = ({
  loopId,
  ...options
}: {
  loopId?: string;
} & Partial<Omit<UseQueryOptions<TeamsResponse>, 'queryKey' | 'queryFn' | 'select'>> = {}) => {
  return useQuery({
    queryKey: loopId ? teamsQueryKeys.byLoop(loopId) : teamsQueryKeys.all(),
    queryFn: () => TeamsApi.getTeams(loopId ? { loopIds: [loopId] } : undefined),
    ...options,
    select: (data) => associateById(data.data),
  });
};
